import type { SVGProps } from 'react';
const SvgFitScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fit_screen_svg__a)">
      <path
        fill="currentColor"
        d="M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4ZM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2Zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2ZM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2ZM18 8H6v8h12V8Z"
      />
    </g>
    <defs>
      <clipPath id="fit_screen_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFitScreen;
